var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAnalyticsTeaser = function SvgAnalyticsTeaser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 452 232",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1340-7",
    transform: "translate(-445.000000, -78.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(445.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#E2ECE7",
    x: 367,
    y: 20,
    width: 37,
    height: 180,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#F08393",
    x: 377,
    y: 0,
    width: 37,
    height: 200,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#E2ECE7",
    x: 234,
    y: 130,
    width: 37,
    height: 70,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#F08393",
    x: 244,
    y: 110,
    width: 37,
    height: 90,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#E2ECE7",
    x: 100,
    y: 160,
    width: 37,
    height: 40,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#F08393",
    x: 110,
    y: 140,
    width: 37,
    height: 60,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#E2ECE7",
    x: 300,
    y: 80,
    width: 37,
    height: 120,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#F08393",
    x: 310,
    y: 60,
    width: 37,
    height: 140,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#E2ECE7",
    x: 167,
    y: 100,
    width: 37,
    height: 100,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    fill: "#F08393",
    x: 177,
    y: 80,
    width: 37,
    height: 120,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#E2ECE7",
    x: 34,
    y: 130,
    width: 37,
    height: 70,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#F08393",
    x: 44,
    y: 110,
    width: 37,
    height: 90,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-7",
    d: "M449.122497,210 L442.786119,206.435788 L442.350332,206.190657 L442.840593,205.319082 L443.276381,205.564212 L451.276381,210.064212 L452.051114,210.5 L451.276381,210.935788 L443.276381,215.435788 L442.840593,215.680918 L442.350332,214.809343 L442.786119,214.564212 L449.122497,211 L443.03125,211 L0.5,211 L1.11022302e-16,211 L1.11022302e-16,210 L0.5,210 L443.03125,210 L449.122497,210 Z",
    fill: "#F08393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-7-Copy",
    d: "M20,2.20003938 L16.4357878,8.53641668 L16.1906571,8.97220445 L15.3190816,8.48194321 L15.5642122,8.04615544 L20.0642122,0.0461554379 L20.5,-0.728578373 L20.9357878,0.0461554379 L25.4357878,8.04615544 L25.6809184,8.48194321 L24.8093429,8.97220445 L24.5642122,8.53641668 L21,2.20003938 L21,8.29128606 L21,230.407692 L21,230.907692 L20,230.907692 L20,230.407692 L20,8.29128606 L20,2.20003938 Z",
    fill: "#F08393"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalyticsTeaser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analyticsTeaser.8279e322.svg";
export { ForwardRef as ReactComponent };